module.exports = __webpack_public_path__ + "static/media/btn_people_1075_725.26b4a284.png";